(function ($) {
	'use strict';

	$(function () {
		$('.js-community-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navParent = $('.js-community-carousel-nav', sliderContainer);
			const numSlides = sliderEl.querySelectorAll('.js-community-carousel-slide').length;

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				loop: false,
				initialSlide: numSlides > 2 ? 1 : 0,
				slidesPerView: 1,
				autoHeight: true,
				centeredSlides: true,
				navigation: false,
				breakpointsBase: 'container',
				slidesPerGroup: 1,
				speed: 1000,
				spaceBetween: 12,

				breakpoints: {
					744: {
						spaceBetween: 16,
					},

					1280: {
						spaceBetween: 20,
					},

					1600: {
						spaceBetween: 40,
					}
				},

				on: {
					beforeInit: function () {
						checkifSwiperNavRequiredSimple(numSlides, navParent, 1);
					},

					resize: function () {
						checkifSwiperNavRequiredSimple(numSlides, navParent, 1);
					},

					reachBeginning: function () {
						setSwiperNavAtBeginning(sliderContainer)
					},

					reachEnd: function () {
						setSwiperNavAtEnd(sliderContainer)
					},

					progress: function () {
						setSwiperNavOtherClasses(sliderContainer, this);
					}
				}
			});

			setupSwiperNavButtons(sliderContainer, swiper);
		});
	});
})(jQuery, document, window);
